import { render, staticRenderFns } from "./CustomAttributesManagement.vue?vue&type=template&id=7657637a"
import script from "./CustomAttributesManagement.vue?vue&type=script&lang=ts"
export * from "./CustomAttributesManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports